import React from 'react';

export default function Button({
  size = '',
  variant = '',
  isOutline = false,
  color = 'white',
  children,
  btnClasses = '',
  icon = null,
  rounded = false,
  borderStyle = '',
  ...rest
}) {
  return (
    <button
      {...rest}
      className={` btn--${size} bg--${variant} ${
        isOutline
          ? `border-full--${borderStyle} bg--transparent text--${color}`
          : `text--${color}`
      } ${rounded ? `radius--full` : `radius--sm`} ${btnClasses}`}
    >
      <span className="d--flex">{icon && icon}</span> {children}
    </button>
  );
}
